import { render, staticRenderFns } from "./GameKeyboard.vue?vue&type=template&id=41c073fc&scoped=true&"
import script from "./GameKeyboard.vue?vue&type=script&lang=js&"
export * from "./GameKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./GameKeyboard.vue?vue&type=style&index=0&id=41c073fc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c073fc",
  null
  
)

export default component.exports